import React, { useMemo } from 'react';
import { LISTING_ENGINE_FUEL_TYPE } from '../../../constants/listing.constants';
import { useIntl } from 'react-intl';
import DropdownFilterEnum from '../DropdownFilterEnum/DropdownFilterEnum';

import css from './SearchPageStyles.module.css';

const fuelTypes = Object.values(LISTING_ENGINE_FUEL_TYPE);

const SEARCH_PARAM_NAME = 'fuelType';

const FuelTypeFilter = props => {
  const intl = useIntl();

  const fuelTypeDropdownOptions = useMemo(
    () =>
      fuelTypes.map(fuelType => ({
        value: fuelType,
        label: intl.formatMessage({ id: `General.listing.fuelType.${fuelType}` }),
        searchString: intl.formatMessage({ id: `General.listing.fuelType.${fuelType}` }),
      })),
    []
  );

  return (
    <div className={css.row}>
      <DropdownFilterEnum
        options={fuelTypeDropdownOptions}
        searchParamName={SEARCH_PARAM_NAME}
        placeholder={intl.formatMessage({ id: 'EditListingDetailsForm.fuelType' })}
        dropdownInputClassName={css.dropdownLabel}
        disableInternalSort
        {...props}
      />
    </div>
  );
};

export default FuelTypeFilter;
